import { useEffect, useState } from 'react';
import { Col, Row, Spin, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { api, formatBytes, Stats } from '../../services/api';
import './dashboard.css';

const CARDS = [
  { key: 'images', label: '图片', path: '/images', color: '#1a6cf0' },
  { key: 'videos', label: '视频', path: '/videos', color: '#0f9f6e' },
  { key: 'bgm', label: '音乐', path: '/bgm', color: '#0e7490' },
  { key: 'sfx', label: '音效', path: '/sfx', color: '#d97706' },
] as const;

export default function DashboardPage() {
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    api
      .stats()
      .then(setStats)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="center-box">
        <Spin size="large" />
      </div>
    );
  }

  const typeTotal = (key: (typeof CARDS)[number]['key']) => {
    const block = stats?.[key];
    return block?.total ?? 0;
  };

  return (
    <div className="dash">
      <div className="dash-head">
        <div>
          <Typography.Title level={3} className="tech-title dash-title">
            资源总览
          </Typography.Title>
          <Typography.Text type="secondary">按类型独立管理图片、视频、音乐与音效</Typography.Text>
        </div>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <div className="tech-panel stat-card">
            <div className="label">资源总量</div>
            <div className="value">{stats?.total ?? 0}</div>
          </div>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <div className="tech-panel stat-card">
            <div className="label">存储占用</div>
            <div className="value">{formatBytes(stats?.total_size ?? 0)}</div>
          </div>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <div className="tech-panel stat-card">
            <div className="label">启用图片</div>
            <div className="value">{stats?.images?.active ?? 0}</div>
          </div>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <div className="tech-panel stat-card">
            <div className="label">API 客户端</div>
            <div className="value">{stats?.clients ?? 0}</div>
          </div>
        </Col>
      </Row>

      <Typography.Title level={5} style={{ marginTop: 28, marginBottom: 14 }}>
        分类管理
      </Typography.Title>
      <Row gutter={[16, 16]}>
        {CARDS.map((card) => (
          <Col xs={12} md={6} key={card.key}>
            <div className="tech-panel type-card" onClick={() => nav(card.path)} role="button" tabIndex={0}>
              <div className="type-label" style={{ color: card.color }}>
                {card.label}
              </div>
              <div className="type-value">{typeTotal(card.key)}</div>
              <div className="type-bar">
                <div
                  className="type-bar-inner"
                  style={{
                    width: `${Math.min(100, (typeTotal(card.key) / Math.max(stats?.total || 1, 1)) * 100)}%`,
                    background: card.color,
                  }}
                />
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}
